import StopStatusLog from './styled';

export default StopStatusLog;
